import type { FlowExecutionType } from "@/types/entities/flows";
import { Badge } from "@elaniintc/goes-design-system";

const getExecutionStateName = (status: FlowExecutionType["status"]) => {
  switch (status) {
    case "PENDING":
      return "Pendiente";
    case "RUNNING":
      return "En progreso";
    case "COMPLETED":
      return "Completado";
    case "FAILED":
      return "Fallido";
    case "CANCELLED":
      return "Cancelado";
    case "EXPIRED":
      return "Expirado";
    case "UNPROCESSED":
      return "No procesado";
    default:
      return status;
  }
};

export const getExecutionBadge = (status: FlowExecutionType["status"]) => {
  const stateName = getExecutionStateName(status);
  switch (status) {
    case "PENDING":
      return (
        <Badge variant="neutral" size="sm">
          {stateName}
        </Badge>
      );
    case "RUNNING":
      return (
        <Badge variant="info" size="sm">
          {stateName}
        </Badge>
      );
    case "COMPLETED":
      return (
        <Badge variant="success" size="sm">
          {stateName}
        </Badge>
      );
    case "FAILED":
      return (
        <Badge variant="danger" size="sm">
          {stateName}
        </Badge>
      );
    case "CANCELLED":
      return (
        <Badge variant="warning" size="sm">
          {stateName}
        </Badge>
      );
    case "EXPIRED":
      return (
        <Badge variant="warning" size="sm">
          {stateName}
        </Badge>
      );
    case "UNPROCESSED":
      return (
        <Badge variant="neutral" size="sm">
          {stateName}
        </Badge>
      );
    default:
      return <span>{status}</span>;
  }
};
